import { combineReducers } from 'redux'
import * as actions from '../actions'
import booleanReducer from '../utils/booleanReducer'

export const initialState = {
  isPosting: false,
  postError: null,
  vipData: null
}

const isPosting = booleanReducer({
  defaultState: initialState.isPosting,
  trueTypes: [actions.POST_NEW_VIP_REQUEST, actions.POST_VIP_CONVERT_REQUEST],
  falseTypes: [actions.POST_NEW_VIP_SUCCESS, actions.POST_NEW_VIP_FAILURE,
    actions.POST_VIP_CONVERT_SUCCESS, actions.POST_VIP_CONVERT_FAILURE],
})

const postError = (state = initialState.postError, { type, payload }) => {
  if (type === actions.POST_NEW_VIP_FAILURE) {
    return 'Error creating new VIP.'
  }
  if (type === actions.POST_VIP_CONVERT_FAILURE) {
    return 'Error converting to new VIP.'
  }

  const otherTypes = [actions.POST_NEW_VIP_REQUEST, actions.POST_NEW_VIP_SUCCESS,
    actions.POST_VIP_CONVERT_REQUEST, actions.POST_VIP_CONVERT_SUCCESS]

  if (otherTypes.some(x => x === type)) {
    return null
  }
  return state
}

const vipData = (state = initialState.vipData, { type, payload }) => {
  if (
    type === actions.POST_NEW_VIP_SUCCESS ||
    type === actions.POST_VIP_CONVERT_SUCCESS
  ) {
    return payload
  }
  return state
}

export default combineReducers({
  isPosting,
  postError,
  vipData
})



// WEBPACK FOOTER //
// ./src/reducers/vip.js